import { memo, type ReactNode } from 'react'

import { Anchor, type AnchorProps, Group } from '@mantine/core'

import { IconLookupTx } from '@repo/common/components/Icons'

export const CryptoLookupTxLinkOld = memo<
  AnchorProps & {
    address: CryptoAddress | ''
    base_url: string
    children?: ReactNode
  }
>(function CryptoLookupTxLinkOld({ children, address, base_url, ...props }) {
  return (
    <Anchor
      target="_blank"
      href={`${base_url}/search?q=${address}`}
      underline="never"
      {...props}
    >
      <Group gap="2px" align="center">
        {children}
        <IconLookupTx size="1.2em" title="lookup tx" />
      </Group>
    </Anchor>
  )
})
